import styled from "styled-components";

export const SubMenuMinDimensions = styled.div<{
  spaceMinHeight?: number;
  spaceMinWidth?: number;
  maxWidth?: string;
  alignItems?: string;
  alignSelf?: string;
  justifyContent?: string;
}>`
  display: flex;
  align-items: ${({alignItems}) => alignItems ?? "center"};
  align-self: ${({alignSelf}) => alignSelf ?? "start"};
  max-width: ${({maxWidth}) => maxWidth ?? "100%"};
  justify-content: ${({justifyContent}) => justifyContent ?? "flext-start"};

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        ${
          props.spaceMinHeight
            ? `min-height: ${props.theme.spacePx(
                breakpoint,
                props.spaceMinHeight
              )}`
            : ""
        };
        ${
          props.spaceMinWidth
            ? `min-width: ${props.theme.spacePx(
                breakpoint,
                props.spaceMinWidth
              )}`
            : ""
        };
      `;
    })}
`;
